const funcion5 = {
    titulo: `Función: retorno de un valor number, string o boolean`,
    problemas: [
      {
        codigo:1,
        descripcion: `Ya sabemos que una función la definimos mediante un nombre y que puede recibir datos por medio de sus parámetros, e inclusive modificar datos de un Array u objeto que le pasamos como parámetro.
Ahora veremos que una función puede retornar un valor numérico, string o boolean. Aparece una palabra clave llamada return, que nos permite retornar un valor de una función.
La sintaxis es la siguiente:
<pre>
function [nombre]([parametros]) {
    [algoritmo]
    return [dato]
}
</pre>
Cuando llamamos a la función, el valor que retorna lo podemos guardar en una variable.
Por ejemplo la siguiente función le enviamos como parámetro el valor del lado de un cuadrado (valor 5) y nos retorna su superficie.`,
programa: `function retornarSuperficie(lado) {
  const superficie = lado * lado
  return superficie
}

const cuadrado1 = retornarSuperficie(5)
console.log(cuadrado1)`,
        solucion: "25"
      },{
        codigo:2,
        descripcion: `El valor devuelto por la función podemos pasarlo directamente al método log de la clase console para que lo muestre.`,
programa: `function retornarSuperficie(lado) {
  const superficie = lado * lado
  return superficie
}
  
console.log(retornarSuperficie(5))`,
        solucion: "25"
      },{
        codigo:3,
        descripcion: `Inmediatamente el algoritmo de la función encuentra la palabra clave return, termina su ejecución. Puede haber varios return dentro de la función, pero solo uno de ellos se ejecutará.`,
programa: `function mayor(valor1, valor2) {
  if (valor1 > valor2) {
    return valor1
  } else {
    return valor2
  }
}

const m = mayor(10, 70)
console.log(m)`,
        solucion: "70"
      },{
        codigo:4,
        descripcion: `Si nos olvidamos de poner la palabra clave return, la función retornará el valor undefined.`,
programa: `function retornarSuperficie(lado) {
  const superficie = lado * lado
}

const cuadrado1 = retornarSuperficie(5)
console.log(cuadrado1)`,
        solucion: "undefined"
      },{
        codigo:5,
        descripcion: ``,
programa: `function mayor(arreglo) {
  let mayor = arreglo[0]
  for (let i = 0; i < arreglo.length; i++) {
    if (arreglo[i] > mayor) {
      mayor = arreglo[i]
    }
  }
  return mayor
}

console.log(mayor([70, 50, 20, 53, 170, 5]))
`,
        solucion: "170"
      },{
        codigo:6,
        descripcion: `Una palabra es un palindromo si es igual al escribir la misma palabra en forma inversa.`,
programa: `function palindromo(cad) {
  const cadena = cad.toLowerCase()
  const cadena_invertida = cadena.split("").reverse().join("")
  if (cadena === cadena_invertida) {
    return true;
  } else {
    return false;
  }
}

if (palindromo('rayar')) {
  console.log('es palindromo')
} else {
  console.log('no es palindromo')
}`,
        solucion: "'es palindromo'"
      },{
        codigo:7,
        descripcion: `Analizar el algoritmo de la siguiente función:`,
programa: `function producto(a, b) {
  const p = a * b
  return prod
}

console.log(producto(2, 3))`,
        solucion: ""
      }
    ]
  }

export default funcion5;